<template>
  <b-container>
    <b-row v-if="visibleModalContent">
      <b-col class="form-area">
        <div class="px-3 py-3 h-100 d-flex flex-column">
          <div class="pb-1">
            <span class="title">
              <i
                class="fal fa-prescription-bottle mr-2"
                aria-hidden="true"
              />
              {{ $t('entities.sample.sample') }}
              {{ entitySelected.label }}
            </span>
          </div>
          <div class="mt-2">
            <div class="form-label">
              <label>{{ $t('diagnosis.modals.sampleReviewType') }}</label>
            </div>
            <vt-combo-select
              ref="entityRevisionTypesCombo"
              v-model="selectedReviewType"
              v-validate="'required'"
              qa="diagnosis-sampleReviewType"
              :class="{ requiredform: (showErrors && !selectedReviewType) }"
              track-by="code"
              :option-loader="getRevisionTypes"
              :allow-empty="false"
              label="translatedName"
            />
          </div>
          <div class="mt-2">
            <div class="form-label">
              <label>{{ $t('diagnosis.modals.reviewResponsible') }}</label>
            </div>
            <vt-combo-select
              ref="responsiblePersonnelCombo"
              v-model="selectedResponsiblePersonnel"
              qa="diagnosis-sampleReviewResponsible"
              :option-loader="getPersonnelGrossingResponsible"
              label="fullName"
              track-by="id"
            />
          </div>
          <div class="my-2 d-flex flex-column h-100">
            <div class="form-label">
              <label>{{ $t('global.observations') }}</label>
            </div>
            <b-form-textarea
              v-model="observations"
              class="flex-grow-1"
              qa="diagnosis-sampleReviewObservations"
              no-resize
            />
          </div>
        </div>
      </b-col>
      <b-col class="thumbs-area">
        <div>
          <p class="description">
            {{ $t('diagnosis.modals.picturesHelpText') }}
          </p>
        </div>
        <div class="scroll-area">
          <vt-thumbnail
            v-for="(attachment) in attachments"
            :key="attachment.attachmentId"
            ref="attachmentThumbnail"
            :laboratory-id="loggedLaboratoryId"
            :case-id="caseId"
            :sample-id="sampleId"
            :attachment="attachment"
            @attachmentChecked="getAttachmentsChecked"
            @attachmentSelected="openUrl($event)"
          />
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import VtThumbnail from '@/components/common/VtThumbnail'
import { personnelService } from '@/api/resources/personnelService'
import revisionTypeServices from '@/api/resources/common/revisionTypeServices'
import ReviewMixin from '@/modules/diagnosisModule/views/form/modals/reviewModal/mixins/ReviewMixin'
import { REVISION_ENTITY_TYPE } from '@/modules/diagnosisModule/constants/revisionEntityType'
import { CommonResponsibilityCodeEnum } from '@/api/services/common/responsibility/common-responsibility.dto'
const sampleAttachmentService = () => import('@/api/resources/attachment/sampleAttachmentService')
const DiagnosisSampleService = () => import('@/modules/diagnosisModule/services/DiagnosisSampleService')

export default {
    name: 'SampleReview',
    components: { VtThumbnail },
    mixins: [ ReviewMixin ],
    props: {
        entitySelected: { type: Object },
        loggedLaboratoryId: { type: Number },
        entityCurrentLaboratoryId: { type: Number },
        caseId: { type: Number },
        sampleId: { type: Number },
        sampleGrossingResponsible: { type: Object }
    },
    data() {
        return {
            selectedEntityAttachments: [],
            selectedRevisionAttachments: [],
            selectedReviewType: null,
            selectedResponsiblePersonnel: this.sampleGrossingResponsible,
            showErrors: false,
            attachments: [],
            observations: ''
        }
    },
    computed: {
        ENTITY_TYPE_SAMPLE() {
            return REVISION_ENTITY_TYPE.SAMPLE
        },
        request() {
            return {
                observations: this.observations,
                revisionAttachments: this.selectedRevisionAttachments.map(attachmentComponent => {
                    return {
                        attachmentEntityType: attachmentComponent.attachment.attachmentEntityType,
                        attachmentId: attachmentComponent.attachment.attachmentId
                    }
                }),
                revisionResponsibleId: this.selectedResponsiblePersonnel ? this.selectedResponsiblePersonnel.id : null,
                type: this.selectedReviewType.code
            }
        },
        visibleModalContent() {
            return !!this.entitySelected
        }
    },
    mounted() {
        this.initializeCalls()
    },
    methods: {
        cleanData() {
            this.$_cleanComponentData()
            this.$refs.entityRevisionTypesCombo.clearInternalOptions()
            this.$refs.responsiblePersonnelCombo.clearInternalOptions()
        },
        getAttachmentsChecked() {
            this.selectedRevisionAttachments = this.$refs.attachmentThumbnail ? this.$refs.attachmentThumbnail.filter(thumbnail => thumbnail.isSelected) : []
        },
        async initializeCalls() {
            let attachmentCallPromises = []
            await DiagnosisSampleService().then(service => {
                this.createRevisionCall = service.default
            })
            await sampleAttachmentService().then(service => {
                attachmentCallPromises.push({
                    call: service.default.getAttachments(
                        this.loggedLaboratoryId,
                        this.caseId,
                        this.sampleId),
                    entityType: this.ENTITY_TYPE_SAMPLE
                })
            })
            this.attachments = await this.getAttachments(attachmentCallPromises)
        },
        getPersonnelGrossingResponsible() {
            return personnelService.getPersonnelByLaboratoryAndResponsibility(this.entityCurrentLaboratoryId, CommonResponsibilityCodeEnum.GROSSING_RESPONSIBLE)
        },
        getRevisionTypes() {
            return revisionTypeServices.getAllSampleRevisionTypes(this.entitySelected?.sampleType?.workflow)
        }
    }
}
</script>

<style scoped>

</style>
